import { useSelector } from 'react-redux';
import { basNetworkContextPageKeys, guidedSectionMapping } from '../../const';
import BasDocuments from './BasDocuments';
import PreferredEquipmentTypes from './PreferredEquipmentTypes';
import { useEffect, useState } from 'react';
import { CongratsTemplate } from '../../CommonTemplates';
import { useDispatch } from 'react-redux';
import { updateSectionStatusThunk } from '../../../../../redux/inputSheet/inputSheetSlice';

function NetworkContextOnboarding({ onClose, setShowSnackbar }) {
	const [pageNumber, setPageNumber] = useState(0);

	const networkOnboardingPages = {
		[basNetworkContextPageKeys.BAS_DOCUMENTS]: (
			<BasDocuments
				setShowSnackbar={setShowSnackbar}
				setPageNumber={setPageNumber}
			/>
		),
		[basNetworkContextPageKeys.PREFERRED_EQUIPMENT_TYPES]: (
			<PreferredEquipmentTypes
				setShowSnackbar={setShowSnackbar}
				setPageNumber={setPageNumber}
			/>
		),
		[basNetworkContextPageKeys.SUCCESS]: (
			<NetworkContextSuccess onClose={onClose} />
		),
	};

	return <>{networkOnboardingPages[pageNumber]}</>;
}

function NetworkContextSuccess({ onClose }) {
	const dispatch = useDispatch();
	const propertyId = useSelector((state) => state.selectedBuilding.prop_id);

	const handleClose = () => {
		dispatch(
			updateSectionStatusThunk({
				propertyId,
				data: {
					[guidedSectionMapping['Network Context'].key]: {
						isComplete: true,
						isStarted: true,
						section_id: guidedSectionMapping['Network Context'].section_id,
					},
				},
			})
		);
		onClose();
	};

	return (
		<CongratsTemplate
			title="Thank you!"
			message="Your information has been saved successfully."
			onClick={handleClose}
		/>
	);
}

export default NetworkContextOnboarding;
